import SmartySDK from 'smartystreets-javascript-sdk';

function buildAutocompleteClient(key: string) {
  if (!key) {
    throw new Error('No SMARTYSTREETS_EMBEDDED_KEY found in environment');
  }

  const credentials = new SmartySDK.core.SharedCredentials(key);

  // The appropriate license values to be used for your subscriptions
  // can be found on the Subscription page of the account dashboard.
  // https://www.smarty.com/docs/cloud/licensing
  const clientBuilder = new SmartySDK.core.ClientBuilder(credentials).withLicenses([
    'us-autocomplete-pro-cloud',
  ]);
  // .withBaseUrl("");
  return clientBuilder.buildUsAutocompleteProClient();
}

export { buildAutocompleteClient };
